import React from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import AppRoutes from './AppRoutes';

const AppRouter = (props) => {
    return (
        <Router>
            <AppRoutes {...props} />
        </Router>
    );
};

export default AppRouter;
